
<template>
  <el-row :gutter="15" style="display: flex">
    <!-- left side is the table of data -->
    <el-col id="left-side" style="padding: 0px; min-width: 200px" :span="12">
      <slot name="table"></slot>
    </el-col>
    <div
      @mousedown="mouseDownHandler"
      id="draggable"
      style="
        width: 20px;
        cursor: ew-resize;
        justify-content: center;
        align-items: center;
        display: flex;
      "
    >
      ⋮
    </div>
    <!-- right side is the task or job details that is selected -->
    <el-col id="right-side" style="padding: 0px; flex: 1 1 0%" :span="12">
      <slot name="details"></slot>
    </el-col>
  </el-row>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    mouseDownHandler(e) {
      // Get the current mouse position

      let leftSide = document.getElementById("left-side");
      this.x = e.clientX;
      this.y = e.clientY;

      this.leftWidth = leftSide.getBoundingClientRect().width;

      document.addEventListener("mousemove", this.mouseMoveHandler);
      document.addEventListener("mouseup", this.mouseUpHandler);
    },
    mouseMoveHandler(e) {
      // How far the mouse has been moved
      const dx = e.clientX - this.x;
      //const dy = e.clientY - this.y;
      let leftSide = document.getElementById("left-side");
      let resizer = document.getElementById("draggable");

      const newLeftWidth =
        ((this.leftWidth + dx) * 100) /
        resizer.parentNode.getBoundingClientRect().width;

      leftSide.style.width = `${newLeftWidth}%`;
    },
    mouseUpHandler() {
      let rightSide = document.getElementById("draggable");
      let leftSide = document.getElementById("draggable");

      document.body.style.removeProperty("cursor");

      leftSide.style.removeProperty("user-select");
      leftSide.style.removeProperty("pointer-events");

      rightSide.style.removeProperty("user-select");
      rightSide.style.removeProperty("pointer-events");

      // Remove the handlers of `mousemove` and `mouseup`
      document.removeEventListener("mousemove", this.mouseMoveHandler);
      document.removeEventListener("mouseup", this.mouseUpHandler);
    },
  },
};
</script>
<style scoped>
.card {
  font-size: 14px;
  color: #606266;
}
.el-card :deep(.el-card__header) {
  background-color: #f0f0f0;
  padding: 10px 20px;
}
.el-card :deep(.el-card__body) {
  padding: 10px 20px;
}
</style>

